//-----------------
// is capped ticks
//-----------------
export default function isCappedTicks(parm) {
   
  const ticks = Number(parm.ticks) || 0
  const max = Number(parm.max) || 0

  // console.log('ticks = ', ticks)
  // console.log('max = ', max)

  return ticks >= max
}
